/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */

export async function loadCityDetails(searchFilter) {
  return await api
    .post(`/protected/getcity`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadStateDetails(searchFilter) {
  return await api
    .post(`/protected/getstate`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadCountryDetails(searchFilter) {
  return await api
    .post(`/protected/getcountry`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
   loadCityDetails,
   loadStateDetails,
   loadCountryDetails
};

export default remotes;